// extracted by mini-css-extract-plugin
module.exports = {"showMore":"ExpandableText_showMore__R3xXe"};